'use client';
import { useMixpanel } from '@/hooks/useMixpanel';
import { useSessionUser, useUserProfile } from '@arcane-ai/core/stores';
import { ReactNode } from 'react';

const MixpanelProvider = ({ children }: { children: ReactNode }) => {
  const user = useSessionUser();
  const { profile } = useUserProfile();
  useMixpanel(user, profile);
  return <>{children}</>;
};

export default MixpanelProvider;
